import { NgIf } from '@angular/common';
import { Directive, Input, OnChanges } from '@angular/core';
import { Klarna } from '@df/module-klarna/klarna.namespace';

@Directive({
    selector: '[ifKlarnaPayment]',
    standalone: true
})
export class IfKlarnaPaymentDirective extends NgIf implements OnChanges {
    @Input({
        required: true
    })
    ifKlarnaPayment!: string;

    ngOnChanges() {
        this.ngIf = this.isKlarnaPayment();
    }

    protected isKlarnaPayment(): boolean {
        if (this.ifKlarnaPayment) {
            const klarnaMethods = Object.values(Klarna.Methods) as string[];
            return klarnaMethods.indexOf(this.ifKlarnaPayment) > -1;
        }
        return false;
    }
}
